import type { MessageKey } from './en';

/** नेपाली — complete; any future key falls back to English. */
export const ne: Partial<Record<MessageKey, string>> = {
  'app.tagline': 'कल ब्रेक · तीन पत्ती · पोकर · म्यारिज',
  'common.continue': 'जारी राख्नुहोस्',
  'common.back': 'पछाडि',
  'common.cancel': 'रद्द गर्नुहोस्',
  'common.close': 'बन्द',
  'common.save': 'सेभ गर्नुहोस्',
  'common.retry': 'फेरि प्रयास गर्नुहोस्',
  'common.loading': 'लोड हुँदैछ…',
  'common.done': 'सकियो',
  'common.skip': 'छोड्नुहोस्',
  'common.coins': 'सिक्का',
  'common.online': '{n} अनलाइन',
  'common.copy': 'कपी',
  'common.copied': 'कपी भयो!',
  'common.share': 'सेयर',
  'common.level': 'लेभल {n}',
  'common.claim': 'लिनुहोस्',
  'common.claimed': 'लिइसकियो',
  'common.seeAll': 'सबै हेर्नुहोस्',
  'error.generic': 'केही गडबड भयो। फेरि प्रयास गर्नुहोस्।',
  'error.network': 'सर्भरमा पुग्न सकिएन। इन्टरनेट जाँच गर्नुहोस्।',
  'error.offline': 'तपाईं अफलाइन हुनुहुन्छ। हामी आफैं जोड्नेछौं।',
  'error.reconnecting': 'जडान टुट्यो। फेरि जोड्दैछौं…',
  'error.maintenance': 'छोटो मर्मत हुँदैछ। केही मिनेटपछि प्रयास गर्नुहोस्।',
  'nav.home': 'गृह',
  'nav.play': 'खेल्नुहोस्',
  'nav.friends': 'साथी',
  'nav.ranks': 'र्‍याङ्क',
  'nav.profile': 'प्रोफाइल',
  'onboard.welcome.title': 'जुनसुकै बेला तासको रमाइलो।',
  'onboard.welcome.body': 'साथीहरूसँग मनपर्ने तास खेल खेल्नुहोस्। निःशुल्क सिक्का, वास्तविक पैसा होइन।',
  'onboard.welcome.cta': 'सुरु गरौं',
  'onboard.welcome.login': 'मेरो खाता छ',
  'onboard.username.title': 'खेलाडीको नाम छान्नुहोस्',
  'onboard.avatar.title': 'आफ्नो अवतार छान्नुहोस्',
  'onboard.signup.title': 'खाता सुरक्षित गर्नुहोस्',
  'onboard.bonus.title': 'स्वागत उपहार!',
  'onboard.bonus.body': 'तपाईंको वालेटमा {amount} सिक्का थपियो।',
  'onboard.favorite.title': 'तपाईंलाई कुन खेल मन पर्छ?',
  'onboard.tutorial.title': 'छोटो सिकाइ?',
  'onboard.tutorial.yes': 'सिकाउनुहोस्',
  'onboard.tutorial.no': 'अहिले खेल्ने',
  'auth.login': 'साइन इन',
  'auth.guest': 'अतिथिको रूपमा जारी राख्नुहोस्',
  'onboard.welcome.games': '{n} कार्ड खेल',
  'onboard.welcome.perkCoins': 'निःशुल्क सिक्का',
  'onboard.welcome.perkBots': 'बोटसँग अभ्यास',
  'auth.register': 'खाता बनाउनुहोस्',
  'auth.username': 'प्रयोगकर्ता नाम',
  'auth.password': 'पासवर्ड',
  'auth.logout': 'साइन आउट',
  'lobby.quickPlay': 'छिटो खेल',
  'lobby.privateRoom': 'निजी कोठा',
  'lobby.daily': 'दैनिक',
  'lobby.missions': 'मिसन',
  'lobby.store': 'पसल',
  'lobby.watchAd': 'निःशुल्क सिक्का',
  'lobby.games': 'खेलहरू',
  'lobby.recent': 'हालका खेल',
  'games.search': 'खेल खोज्नुहोस्',
  'games.clear': 'खोजी हटाउनुहोस्',
  'games.noMatch': '"{q}" सँग मिल्ने कुनै खेल भेटिएन',
  'games.results': '{n} खेल भेटिए',
  'games.favourites': 'मनपर्ने',
  'games.recentlyPlayed': 'हालै खेलेका',
  'games.all': 'सबै खेल',
  'games.favAdd': '{game} लाई मनपर्नेमा थप्नुहोस्',
  'games.favRemove': '{game} लाई मनपर्नेबाट हटाउनुहोस्',
  'lobby.rejoin': 'फेरि जोडिनुहोस्',
  'lobby.joinRoom': 'कोडबाट जोडिनुहोस्',
  'lobby.howToPlay': 'कसरी खेल्ने',
  'game.CALL_BREAK': 'कल ब्रेक',
  'game.SPADES': 'स्पेड्स',
  'game.TARNEEB': 'तरनीब',
  'game.HEARTS': 'हार्ट्स',
  'game.FIVE_HUNDRED': 'फाइभ हन्ड्रेड',
  'game.JUDGEMENT': 'जजमेन्ट',
  'game.RUMMY': 'रमी',
  'game.EUCHRE': 'युकर',
  'game.GIN_RUMMY': 'जिन रमी',
  'game.TWENTY_NINE': 'उनन्तीस (२९)',
  'game.CRAZY_EIGHTS': 'क्रेजी एट्स',
  'game.CRIBBAGE': 'क्रिबेज',
  'game.BLACKJACK': 'ब्ल्याकज्याक',
  'game.BHABHI': 'भाउजू (थुल्ला)',
  'game.PINOCHLE': 'पिनोकल',
  'game.ANDAR_BAHAR': 'भित्र बाहिर',
  'game.BRIDGE': 'ब्रिज',
  'game.SEVENS': 'सत्ते पे सत्ता',
  'game.SCOPA': 'स्कोपा',
  'game.BACCARAT': 'बकारा',
  'game.BLUFF': 'ब्लफ (चिट)',
  'game.DRAGON_TIGER': 'ड्रागन टाइगर',
  'game.FLUSH': 'फ्लश',
  'game.COURT_PIECE': 'कोर्ट पीस',
  'game.DEHLA_PAKAD': 'दहला पकड',
  'dp.firstFive': 'पहिलो पाँच पत्ताबाट तुरुप छान्नुहोस्',
  'dp.outcome.KOT': 'कोट! एउटा टोलीले सबै १३ चाल जित्यो',
  'dp.outcome.MENDICOT': 'मेन्डिकोट — एउटा टोलीले चारै दहला जित्यो',
  'dp.outcome.TENS': 'तीन दहलाले हात तय गर्छ',
  'dp.outcome.TRICKS': 'दहला २–२ बाँडियो — बढी चाल जित्ने टोली जित्यो',
  'dp.scoreHint': '{target} अंक पुग्ने पहिलो टोली जित्छ। चार दहला इनाम हुन्: तीन दहलामा १ अंक, चारै (मेन्डिकोट) मा २, दहला २–२ बाँडिए बढी चाल जित्ने टोलीले १, र सबै १३ चाल (कोट) जित्दा ३ अंक।',
  'wh.hand': 'हात {n}',
  'wh.trump': 'तुरुप',
  'wh.dealerHolds': '{name} सँग पल्टाइएको पत्ता छ',
  'wh.tricks': '{n} चाल',
  'wh.handScores': 'हात {n} को स्कोर',
  'wh.scoreHint': '{target} अङ्क पुग्ने पहिलो जोडी जित्छ। छ भन्दा माथिका चाल मात्र गनिन्छन्।',
  'cnt.hand': 'ह्यान्ड {n}',
  'cnt.stock': 'स्टक {n}',
  'cnt.pile': 'थुप्रो ({n})',
  'cnt.frozen': 'फ्रोजन',
  'cnt.draw': '२ तान्नुहोस्',
  'cnt.take': 'थुप्रो लिनुहोस्',
  'cnt.meld': 'मेल्ड',
  'cnt.discard': 'फाल्नुहोस्',
  'cnt.clear': 'हटाउनुहोस्',
  'cnt.ourMelds': 'हाम्रा मेल्ड',
  'cnt.theirMelds': 'उनीहरूका मेल्ड',
  'cnt.canasta': 'क्यानास्टा',
  'cnt.noMeld': 'अहिलेसम्म छैन',
  'cnt.need': 'पहिलो मेल्डका लागि {n}+ अङ्क चाहिन्छ',
  'cnt.pickRank': 'वाइल्ड कार्ड कुन मेल्डमा थप्ने?',
  'cnt.wildNeedRank': 'वाइल्ड कार्डसँग एउटै रैंकका असली कार्ड छान्नुहोस्',
  'cnt.wentOut': '{name} बाहिरिए',
  'cnt.stockOut': 'स्टक सकियो',
  'cnt.scoreHint': '{target} अङ्क पुग्ने पहिलो जोडी जित्छ। हरेक खाना: मेल्ड + क्यानास्टा + रातो तीन + आउट बोनस − बाँकी पत्ता।',
  'r5.hand': 'हात {n}',
  'r5.stock': 'स्टक {n}',
  'r5.pile': 'डिस्कार्ड पाइल ({n})',
  'r5.tapPile': 'उज्यालो पत्तामा थिच्नुहोस् — माथिका पत्ता पनि आउँछन्',
  'r5.draw': 'तान्नुहोस्',
  'r5.meldBtn': 'मेल्ड',
  'r5.discard': 'फाल्नुहोस्',
  'r5.clear': 'हटाउनुहोस्',
  'r5.melds': 'टेबलमा मेल्ड',
  'r5.noMelds': 'अहिलेसम्म मेल्ड छैन',
  'r5.meld': 'मेल्ड',
  'r5.you': 'तपाईं',
  'r5.wentOut': '{name} बाहिरियो',
  'r5.stockOut': 'स्टक सकियो',
  'r5.layoffHint': 'हातबाट एउटा पत्ता छान्नुहोस्, त्यसपछि मेल्डमा थिच्नुहोस्',
  'r5.noFit': 'यो पत्ता यो मेल्डमा मिल्दैन',
  'r5.mustUse': 'यो पटक लिएको {card} प्रयोग गर्नुहोस्',
  'r5.scoreHint': '{target} अङ्क पुग्ने पहिलो जित्छ। मेल्डका पत्ताले अङ्क थप्छन्, हातमा बाँकी पत्ताले घटाउँछन्।',
  'be.hand': 'हात {n}',
  'be.round1': 'बोली: पत्ता लिने?',
  'be.round2': 'बोली: तुरुप भन्नुहोस्',
  'be.upCard': 'पल्टाइएको पत्ता',
  'be.take': 'लिनुहोस्',
  'be.taker': 'लिने',
  'be.belote': 'बेलोट',
  'be.capot': 'क्यापो',
  'be.bid': 'बोली',
  'be.takeUp': 'पल्टाइएको पत्ताको रङ तुरुप लिने?',
  'be.nameTrump': 'तुरुपको रङ भन्नुहोस् वा पास गर्नुहोस्',
  'be.chooseSuit': 'तुरुपको रङ छान्नुहोस्',
  'be.handScores': 'हात {n} को अङ्क',
  'be.failed': '{name} को जोडी सम्झौता चुक्यो',
  'be.scoreHint': '{target} अङ्क पुग्ने पहिलो जोडीले जित्छ। लिनेलाई विपक्षीभन्दा बढी अङ्क चाहिन्छ; बेलोट-रिबेलोट २० र क्यापोले ९० थप्छ।',
  'pch.hand': 'हात {n}',
  'pch.bidN': 'बोली {n}',
  'pch.bidder': 'बोली लगाउने',
  'pch.bid': 'तपाईंको बोली',
  'pch.toBid': 'बोली लगाउनुहोस् वा पास',
  'pch.stuck': 'सबैले पास गरे: तपाईंले २ को बोली लिनुपर्छ',
  'pch.sets': 'पहिलो पत्ताले तुरुप तोक्छ',
  'pch.bidsInfo': '{name} ले {n} को बोली लगायो',
  'pch.handScores': 'हात {n} को अङ्क',
  'pch.setBack': '{name} को जोडी {n} अङ्कले पछाडि पर्‍यो',
  'pch.high': 'हाई',
  'pch.low': 'लो',
  'pch.jack': 'ज्याक',
  'pch.game': 'गेम',
  'pch.scoreHint': '{target} अङ्क पुग्ने पहिलो जोडीले जित्छ। हाई, लो, ज्याक र गेम जित्नुहोस्: बोली लगाउनेले आफ्नो बोली पूरा गर्नुपर्छ, नत्र अङ्क घट्छ।',
  'pch.pitchIt': 'कुनै पनि पत्ता चल्नुहोस्: त्यसको रङ तुरुप बन्छ',
  'pch.bidWas': 'बोली {n}',
  'bsc.stock': '{n} बाँकी',
  'bsc.trumpCard': 'तुरुप पत्ता',
  'bsc.pts': 'अङ्क',
  'bsc.won': 'जित्यो',
  'bsc.handWon': 'हात जित्यो',
  'bsc.drawn': '60–60 बराबरी — फेरि बाँडिन्छ',
  'bsc.scoreHint': '120 मध्ये 60 भन्दा बढी अङ्कले हात जित्छ। {target} हात जित्ने पहिलो जोडीले म्याच जित्छ।',
  'trs.pts': 'अंक',
  'trs.target': 'पहिले {n} सम्म',
  'trs.thisHand': 'यो हातमा',
  'trs.scoreHint': 'एक्का १ अंकको हो र ३, २, K, Q, J एक-एक तिहाइ अंकका; अन्तिम ट्रिकमा १ अंक थपिन्छ। हरेक हात पूरा अंकमा तल गोलो गरिन्छ। {target} अंक पुग्ने पहिलो जोडी म्याच जित्छ।',
  'game.WHIST': 'ह्विस्ट',
  'game.SEEP': 'सीप',
  'game.BELOTE': 'बेलोट',
  'game.DURAK': 'दुरक',
  'du.cards': '{n} पत्ता',
  'du.out': 'बाहिर · {n}',
  'du.attacker': 'आक्रमणकारी',
  'du.defender': 'रक्षक',
  'du.durakTag': 'दुरक',
  'du.bout': 'चरण {n}',
  'du.stock': 'गड्डी {n}',
  'du.trump': 'तुरुप',
  'du.trumpCard': 'तुरुपको पत्ता',
  'du.defendHint': 'ठूलो पत्ता वा {trump} तुरुपले काट्नुहोस् — वा उठाउनुहोस्',
  'du.cannotBeat': 'तपाईं काट्न सक्नुहुन्न — पत्ता उठाउनुहोस्',
  'du.leadHint': 'कुनै पनि पत्ता चल्नुहोस्',
  'du.pileOnHint': 'उनीहरू उठाउँदैछन् — उही अंकको पत्ता थप्नुहोस् वा पास गर्नुहोस्',
  'du.throwHint': 'उही अंकको पत्ता थप्नुहोस् वा पास गर्नुहोस्',
  'du.took': '{name} ले पत्ता उठायो',
  'du.beaten': 'काटियो — अब {name} ले आक्रमण गर्छ',
  'du.taking': '{name} ले पत्ता उठाउँदैछ',
  'du.noDurak': 'सबै बाहिरिए — कुनै दुरक छैन!',
  'du.isDurak': '{name} दुरक हो!',
  'du.take': 'पत्ता उठाउनुहोस्',
  'du.pass': 'पास',
  'du.player': 'खेलाडी',
  'du.cardsLeft': 'बाँकी पत्ता',
  'du.outShort': 'बाहिर',
  'du.scoreHint': 'हरेक आक्रमणलाई उही रङको ठूलो पत्ता वा तुरुपले काट्नुहोस्, वा पत्ता उठाउनुहोस्। अरूले टेबलमा भएको अंकका पत्ता थप्न सक्छन्। हरेक चरणपछि सबैले छ वटासम्म भर्छन्। गड्डी सकिएपछि पत्ता नभएका खेलाडी बाहिरिन्छन् — अन्त्यमा पत्ता भएको खेलाडी दुरक हो।',
  'game.PRESIDENT': 'प्रेसिडेन्ट',
  'game.BRISCOLA': 'ब्रिस्कोला',
  'game.CASINO_WAR': 'क्यासिनो वार',
  'game.THREE_CARD_POKER': 'थ्री कार्ड पोकर',
  'game.GO_FISH': 'गो फिस',
  'game.TRESSETTE': 'ट्रेसेट',
  'game.RED_DOG': 'रेड डग',
  'game.CANASTA': 'क्यानास्टा',
  'game.SKAT': 'स्क्याट',
  'skt.deal': 'डिल {n}',
  'skt.bid': 'बोली',
  'skt.playing': 'खेल',
  'skt.skat': 'स्क्याट',
  'skt.skatTaken': 'स्क्याट लिइयो',
  'skt.holds': 'होल्ड',
  'skt.declarer': 'डिक्लेरर',
  'skt.cardPts': '{n} अंक',
  'skt.bidding': '{name} बोली लगाउँदै हुनुहुन्छ',
  'skt.looking': '{name} स्क्याट हेर्दै हुनुहुन्छ',
  'skt.choosing': '{name} खेल छान्दै हुनुहुन्छ',
  'skt.redealt': 'सबैले पास गरे, त्यसैले पत्ता फेरि बाँडियो',
  'skt.handScores': 'डिल {n} को नतिजा',
  'skt.won': '{name} जित्नुभयो',
  'skt.lost': '{name} हार्नुभयो',
  'skt.declarerPoints': '{n} कार्ड अंक',
  'skt.with': '{n} सहित',
  'skt.without': '{n} बिना',
  'skt.schneider': 'श्नाइडर',
  'skt.schwarz': 'श्वार्ज',
  'skt.overbid': 'बढी बोली: खेलको मूल्य {value} थियो, बोली {bid} भन्दा कम।',
  'skt.bidTitle': 'तपाईंको बोली',
  'skt.forehandTitle': 'सबैले पास गरे। 18 मा खेल्ने?',
  'skt.current': 'हालको बोली {n}',
  'skt.more': 'थप बोली',
  'skt.respondTitle': 'होल्ड कि पास?',
  'skt.hold': '{n} होल्ड गर्नुहोस्',
  'skt.youWon': 'तपाईंले {n} मा बोली जित्नुभयो',
  'skt.skatHint': 'स्क्याटका दुई पत्ता उठाउनुहोस्, अनि दुई पत्ता हटाएर खेल छान्नुहोस्।',
  'skt.pickup': 'स्क्याट उठाउनुहोस्',
  'skt.declareTitle': 'दुई पत्ता हटाउनुहोस्, अनि खेल छान्नुहोस्',
  'skt.discardCount': '2 मध्ये {n} छानियो',
  'skt.chooseGame': 'खेल',
  'skt.worth': 'मूल्य {value} (आधार {base})',
  'skt.worthLess': 'मूल्य केवल {value}, तपाईंको बोली {bid} भन्दा कम। तपाईं हार्नुहुन्छ।',
  'skt.confirm': '{game} खेल्नुहोस्',
  'skt.game.C': 'चिडी',
  'skt.game.S': 'हुकुम',
  'skt.game.H': 'पान',
  'skt.game.D': 'ईंट',
  'skt.game.GRAND': 'ग्र्यान्ड',
  'skt.game.NULL': 'नल',
  'skt.scoreHint': '{target} अंकमा पहिले पुग्ने जित्छ। डिक्लेररको मात्र अंक बन्छ: जितमा खेलको मूल्य, हारमा त्यसको दोब्बर घट्छ।',
  'game.PAI_GOW': 'पाइ गाउ पोकर',
  'game.BIG_TWO': 'बिग टु',
  'bt.cards': '{n} पत्ता',
  'bt.out': 'बाहिर · {n}',
  'bt.first': 'पहिलो',
  'bt.second': 'दोस्रो',
  'bt.third': 'तेस्रो',
  'bt.last': 'अन्तिम',
  'bt.leadHint': 'तपाईंको पालो — एउटा पत्ता, जोडी, तीन उस्तै वा पाँच पत्ताको हात खेल्नुहोस्',
  'bt.openHint': 'तपाईं सुरु गर्नुहोस् — पहिलो चालमा ♦३ हुनुपर्छ',
  'bt.followHint': '{n} ठूला पत्ताले काट्नुहोस् — वा पास गर्नुहोस्',
  'bt.passed': 'पास',
  'bt.play': 'चल्नुहोस्',
  'bt.pass': 'पास',
  'bt.pile': 'थुप्रो {n}',
  'bt.empty': 'जुनसुकै संयोजन खेल्नुहोस्',
  'bt.player': 'खेलाडी',
  'bt.cardsLeft': 'बाँकी पत्ता',
  'bt.outShort': 'बाहिर',
  'bt.clearedPasses': 'सबैले पास गरे — {name} सुरु गर्छ',
  'bt.isLast': '{name} अन्तिम हो',
  'bt.scoreHint': 'सबैभन्दा पहिले आफ्ना सबै पत्ता खेल्नुहोस्। अघिल्लो चालजति नै पत्ताले काट्नुहोस्, वा पास गर्नुहोस्। दुई सबैभन्दा ठूलो हो; हुकुम अरू सबैभन्दा ठूलो हो।',
  'bt.single': 'एउटा पत्ता',
  'bt.pair': 'जोडी',
  'bt.triple': 'तीन उस्तै',
  'bt.straight': 'सिक्वेन्स',
  'bt.flush': 'फ्लस',
  'bt.fullhouse': 'फुल हाउस',
  'bt.four': 'चार उस्तै',
  'bt.straightflush': 'स्ट्रेट फ्लस',
  'bt.selectHint': 'चाल बनाउन पत्ता छान्नुहोस्, अनि चल्नुहोस् थिच्नुहोस्',
  'game.WAR': 'वार',
  'game.RUMMY_500': 'रमी ५००',
  'game.BRAG': 'थ्री कार्ड ब्र्याग',
  'game.PITCH': 'पिच',
  'game.HAZARI': 'हजारी',
  'sp.bid': 'आफ्नो चाल बोल्नुहोस्',
  'sp.yourBid': 'तपाईंको बोली',
  'sp.bidValue': 'बोली {n}',
  'sp.bidNil': 'निल बोल्नुहोस्',
  'sp.nil': 'निल',
  'sp.nilLong': 'निल (कुनै चाल नजित्ने)',
  'sp.round': 'राउन्ड {n}',
  'sp.broken': 'स्पेड्स खुल्यो',
  'sp.partner': 'साथी',
  'sp.us': 'हामी',
  'sp.them': 'उनीहरू',
  'sp.bags': '{n} ब्याग',
  'sp.bagsWord': 'ब्याग',
  'sp.roundScores': 'राउन्ड {n} को स्कोर',
  'sp.scoreHint': '{target} पुग्ने टोली जित्छ; {lose} मा पुग्ने टोली हार्छ। हरेक 10 ब्यागमा 100 अंक कटौती हुन्छ।',
  'ta.bid': 'आफ्नो चाल बोल्नुहोस्',
  'ta.yourBid': 'तपाईंको बोली',
  'ta.pass': 'पास',
  'ta.bidTag': 'बोली {n}',
  'ta.trump': 'तुरुप',
  'ta.choosing': '{name} तुरुप छान्दै हुनुहुन्छ',
  'ta.passHint': '7 वा सोभन्दा बढी बोल्नुहोस्, वा पास गर्नुहोस्',
  'ta.mustBid': 'सबैले पास गरे — तपाईंले बोली लगाउनुपर्छ',
  'ta.chooseTrump': 'तुरुप छान्नुहोस्',
  'ta.scoreHint': '{target} पुग्ने टोली जित्छ। बोली पूरा भए जितेका चालको अंक पाइन्छ (13 मा 16); चुकेमा बोली बराबर अंक कटौती हुन्छ। रक्षा गर्ने टोलीले आफ्ना चालको अंक पाउँछ।',
  'cp.caller': 'कलर',
  'cp.scoreHint': '{target} कोर्ट जित्ने टोली जित्छ। १३ मध्ये ७ वा बढी चाल जितेमा कोर्ट पाइन्छ; सबै १३ जितेमा २ कोर्ट। कलरले पाँच पत्ता हेरेर रङ (तुरुप) छान्छ र टोली जितुन्जेल भूमिका राख्छ।',
  'hr.dir.left': 'देब्रेतिर',
  'hr.dir.right': 'दाहिनेतिर',
  'hr.dir.across': 'अगाडिको खेलाडी',
  'hr.dir.hold': 'कसैलाई',
  'hr.passTitle': '3 पत्ता {dir}लाई दिनुहोस्',
  'hr.noPass': 'यो राउन्डमा पत्ता दिइँदैन',
  'hr.pickThree': '{n}/3 छानियो',
  'hr.passBtn': 'पत्ता दिनुहोस्',
  'hr.passed': 'दियो',
  'hz.pts': 'अंक',
  'hz.hand': 'हात {n}',
  'hz.handScores': 'हात {n} को अंक',
  'hz.leadHint': 'तपाईंको चाल — कुनै पनि पत्ता खेल्नुहोस्',
  'hz.won': '{name} ले {n} अंक पाए',
  'hz.scoreHint': 'सबैभन्दा बढी अंक भएको जित्छ। खेल तब सकिन्छ जब कुनै खेलाडी सबैभन्दा माथि रहेर {target} पुग्छ, वा {max} हात पछि। प्रत्येक चालमा पत्ताको अंक: एक्का 11, दस 10, राजा 4, रानी 3, गुलाम 2, र अन्तिम चालको 10 थप।',
  'hr.broken': 'हार्ट्स खुल्यो',
  'hr.received': 'तपाईंले पाउनुभयो',
  'hr.moon': '{name} ले चन्द्रमा शूट गर्नुभयो!',
  'hr.scoreHint': 'सबैभन्दा कम स्कोर भएको जित्छ। कुनै खेलाडी {target} पुग्नासाथ खेल सकिन्छ। हरेक हार्ट 1 अंक र हुकुमकी रानी 13 अंकको हो; सबै 26 अंक लिनु चन्द्रमा शूट गर्नु हो।',
  'fh.bid': 'आफ्नो बोली लगाउनुहोस्',
  'fh.yourBid': 'तपाईंको बोली',
  'fh.contract': 'कन्ट्र्याक्ट',
  'fh.choosingDiscard': '{name} पत्ता फाल्दै हुनुहुन्छ',
  'fh.discardTitle': '3 पत्ता फाल्नुहोस्',
  'fh.discardBtn': 'पत्ता फाल्नुहोस्',
  'fh.nameSuit': 'जोकरका लागि रङ भन्नुहोस्',
  'fh.follow': '{suit} हाल्नुहोस्',
  'fh.made': 'पूरा भयो',
  'fh.failed': 'चुक्यो',
  'fh.scoreHint': '{target} पुग्ने टोली जित्छ; -{target} मा पुग्ने टोली हार्छ। पूरा भएको बोलीको मूल्य पाइन्छ (10 चालमा कम्तीमा 250), चुकेमा त्यही कटौती हुन्छ, र अर्को टोलीले हरेक चालको 10 अंक पाउँछ।',
  'ju.bid': 'आफ्नो चालको बोली लगाउनुहोस्',
  'ju.yourBid': 'तपाईंको बोली',
  'ju.bidValue': '{n} को बोली',
  'ju.round': 'राउन्ड {n}/{total}',
  'ju.card': '1 पत्ता',
  'ju.cards': '{n} पत्ता',
  'ju.trump': 'तुरुप',
  'ju.trumpCard': 'तुरुपको पत्ता',
  'ju.hook': 'डिलर भएकाले तपाईं {n} को बोली लगाउन सक्नुहुन्न — बोलीहरूको जोड चालसँग बराबर हुन मिल्दैन।',
  'ju.scoreHint': 'बोली लगाएजति नै चाल जित्नुभयो भने 10 र तपाईंको बोलीजति अंक पाइन्छ; चुक्नुभयो भने चुकेजति अंक कटौती हुन्छ। हरेक राउन्डमा पत्ताको संख्या बदलिन्छ र सबैभन्दा बढी कुल अंक हुने जित्छ।',
  'ru.deal': 'डिल {n}/{total}',
  'ru.wild': 'जोकर: {rank}',
  'ru.cutJoker': 'कट जोकर',
  'ru.points': 'अंक: {n}',
  'ru.dropped': 'ड्रप',
  'ru.drop': 'ड्रप',
  'ru.dropTitle': 'यो डिल ड्रप गर्ने?',
  'ru.dropBody': 'तपाईं यो डिलबाट बाहिरिनुहुन्छ र {n} अंक लिनुहुन्छ।',
  'ru.declare': 'डिक्लेयर',
  'ru.declareTitle': 'आफ्नो हात डिक्लेयर गर्नुहोस्',
  'ru.declareBody': '{card} फाल्नुहोस् र यी समूह देखाउनुहोस्।',
  'ru.notReady': 'अहिले जित्ने हात छैन: एउटा प्योर सिक्वेन्स, दोस्रो सिक्वेन्स र बाँकी सबै पत्ता सिक्वेन्स वा सेटमा चाहिन्छ।',
  'ru.winner': '{name} ले डिक्लेयर गर्नुभयो!',
  'ru.lastPlayer': '{name} जित्नुभयो — अरू सबैले ड्रप गरे',
  'ru.stockOut': 'स्टक सकियो — कोही विजेता छैन',
  'ru.scoreHint': 'सबैभन्दा कम कुल अंक हुने जित्छ। डिल जित्नेले 0 अंक पाउँछ; अरू सबैले समूहमा नपरेका पत्ताको अंक (A/K/Q/J/10 = 10, जोकर 0) पाउँछन्, बढीमा {max}। पहिलो पटक तान्नु अघि ड्रप गरे 20 र पछि 40 अंक लाग्छ।',
  'eu.bid': 'तपाईंको बोली',
  'eu.call': 'तुरुप भन्नुहोस्',
  'eu.orderUp': 'अर्डर अप',
  'eu.orderedUp': 'अर्डर अप गर्यो',
  'eu.called': 'भन्यो',
  'eu.alone': 'एक्लै खेल्ने',
  'eu.callSuit': '{suit} भन्नुहोस्',
  'eu.round1Hint': '{suit} लाई तुरुप बनाउन अर्डर अप गर्नुहोस्, वा पास',
  'eu.round2Hint': 'अर्को रङ भन्नुहोस्, वा पास',
  'eu.mustCall': 'सबैले पास गरे — तपाईंले तुरुप भन्नैपर्छ',
  'eu.turnedUp': 'खुला पत्ता',
  'eu.turnedDown': 'पल्टाइएको · {suit} होइन',
  'eu.discardTitle': 'एउटा पत्ता फाल्नुहोस्',
  'eu.pickUp': 'तपाईंले {card} उठाउनुभयो',
  'eu.discard': 'पत्ता छान्नुहोस्',
  'eu.discardCard': '{card} फाल्नुहोस्',
  'eu.waitingDiscard': '{name} पत्ता फाल्दै हुनुहुन्छ',
  'eu.maker': 'मेकर',
  'eu.sitting': 'बाहिर बसेको',
  'eu.euchred': 'युकर्ड',
  'eu.scoreHint': '{target} पुग्ने टोली जित्छ। मेकरले 3 वा 4 चाल जित्दा 1 अंक, सबै 5 मा 2 अंक (एक्लै खेल्दा 4); कम जित्दा उनीहरू युकर्ड हुन्छन् र अर्को टोलीले 2 अंक पाउँछ।',
  'gr.hand': 'हात {n}',
  'gr.goal': '{n} सम्म',
  'gr.wins': '{n} जित्यो',
  'gr.upcard': 'खुला पत्ता',
  'gr.take': 'खुला पत्ता लिनुहोस्',
  'gr.pass': 'पास',
  'gr.stockOnly': 'दुवैले पास गरे — स्टकबाट तान्नुहोस्',
  'gr.knock': 'नक',
  'gr.gin': 'जिन!',
  'gr.deadwood': 'डेडवुड: {n}',
  'gr.deadwoodLabel': 'डेडवुड',
  'gr.knocked': '{name} ले नक गरेर हात जित्यो',
  'gr.ginned': '{name} ले जिन बनायो!',
  'gr.undercut': '{name} ले नकलाई अन्डरकट गर्यो!',
  'gr.undercutShort': 'अन्डरकट',
  'gr.drawHand': 'हात बराबरी — कसैले अंक पाएन',
  'gr.scoreHint': '{target} पुग्ने जित्छ। 10 वा कम डेडवुडमा नक गर्नुहोस्: फरकको अंक पाइन्छ। जिनमा 25 र उनको डेडवुड; अन्डरकटमा फरक र 25। विजेताले 100 र हरेक जितेको हातको 25 थप पाउँछ।',
  'tn.bid': 'आफ्नो अंकको बोली लगाउनुहोस्',
  'tn.passHint': '{n} वा बढीको बोली लगाउनुहोस्, वा पास',
  'tn.yourTrump': 'तपाईंको तुरुप',
  'tn.trumpHidden': 'तुरुप लुकेको छ',
  'tn.trumpSecret': 'कसैले नमागेसम्म गोप्य',
  'tn.reveal': 'तुरुप माग्नुहोस्',
  'tn.revealHint': 'खेलिएको रङको पत्ता छैन — तुरुप हेर्न भन्नुहोस्',
  'tn.asked': 'मागे',
  'tn.scoreHint': 'पहिले +{target} पुग्ने टोली जित्छ; −{target} मा हार। बोली लगाउनेहरूले आफ्नो बोलीसम्म पत्ताका अंक (J 3, 9 2, A 1, 10 1 — जम्मा 28) ल्याउनुपर्छ: पुगे +1, नपुगे −1। रङ नभएको खेलाडीले तुरुप नमागेसम्म त्यो लुकेको रहन्छ।',
  'ce.goal': '{n} सम्म',
  'ce.suit': 'रङ',
  'ce.lacks': 'पत्ता तान्नुपर्‍यो — यी रङका पत्ता छैनन्',
  'ce.nameSuit': 'रङ छान्नुहोस्',
  'ce.draw': 'पत्ता तान्नुहोस् ({n}/{max})',
  'ce.out': '{name} का सबै पत्ता सकिए!',
  'ce.blocked': 'खेल रोकियो — {name} को हात सबैभन्दा कम छ',
  'ce.blockedNone': 'खेल रोकियो — बराबरी, कसैले अंक पाएन',
  'ce.scoreHint': '{target} पुग्ने जित्छ। पत्ता सक्दा अरूको हातमा बाँकी पत्ताका अंक पाइन्छ (आठ 50, K Q J 10 दश-दश, एक्का 1, बाँकी आफ्नै अंक)। रोकिएको खेलमा सबैभन्दा कम हात भएकाले फरकको अंक पाउँछ।',
  'cg.you': 'तपाईं',
  'cg.dealer': 'डिलर',
  'cg.starter': 'स्टार्टर',
  'cg.crib': '{name} को क्रिब',
  'cg.counting': 'गन्ती हुँदैछ…',
  'cg.nineteen': 'उन्नाइस — कुनै अंक छैन',
  'cg.count': 'जोड {n}',
  'cg.toCrib': 'क्रिबमा पठाउनुहोस् ({n}/2)',
  'cg.playHint': 'पत्ता चल्नुहोस् — जोड 31 भन्दा बढी हुनुहुँदैन',
  'cg.r.fifteen': 'पन्ध्र',
  'cg.r.thirtyone': 'एकतीस',
  'cg.r.pair': 'जोडी',
  'cg.r.pairRoyal': 'तीन उस्तै',
  'cg.r.doubleRoyal': 'चार उस्तै',
  'cg.r.run': '{n} को क्रम',
  'cg.r.lastCard': 'अन्तिम पत्ता',
  'cg.r.heels': 'हिज हिल्स',
  'cg.r.pone': 'हात',
  'cg.r.dealer': 'हात',
  'cg.r.crib': 'क्रिब',
  'cg.i.fifteen': 'पन्ध्र',
  'cg.i.pair': 'जोडी',
  'cg.i.run': 'क्रम',
  'cg.i.flush': 'फ्लस',
  'cg.i.nobs': 'नब्स',
  'cg.scoreHint': '{target} पुग्ने जित्छ। अंक कमाउने बित्तिकै जोडिन्छन्: खेल्दा पन्ध्र र जोडी, त्यसपछि हात र डिलरको क्रिब। पन्ध्रको 2, जोडीको 2, क्रमको लम्बाइ बराबर, फ्लसको 4 वा 5, र स्टार्टरको रङको गुलाम (नब्स) को 1।',
  'bj.dealer': 'डिलर',
  'bj.shoe': 'शू {n}',
  'bj.hand': 'हात',
  'bj.bust': 'बस्ट',
  'bj.r.BLACKJACK': 'ब्ल्याकज्याक!',
  'bj.r.WIN': 'जित',
  'bj.r.PUSH': 'बराबरी',
  'bj.r.LOSE': 'हार',
  'bj.r.BUST': 'बस्ट',
  'bj.sitting': 'यो हातमा छैन',
  'bj.betting': 'बाजी लाग्दैछ…',
  'bj.placeBet': 'आफ्नो बाजी लगाउनुहोस्',
  'bj.limits': 'न्यूनतम {min} · अधिकतम {max}',
  'bj.sitOut': 'छोड्नुहोस्',
  'bj.bet': 'बाजी {n}',
  'bj.actions': 'तपाईंको चाल',
  'bj.stand': 'स्ट्यान्ड',
  'bj.hit': 'हिट',
  'bj.double': 'डबल',
  'bj.split': 'स्प्लिट',
  'bj.waiting': 'खेलाडीको प्रतीक्षा…',
  'bj.handOver': 'हात सकियो',
  'bj.dealerPlays': 'डिलर खेल्दैछ…',
  'bj.wait': 'अरू खेलाडीको प्रतीक्षा…',
  'bh.cards': '{n} पत्ता',
  'bh.out': 'बाहिर · {n}',
  'bh.bhabhiTag': 'भाउजू',
  'bh.voids': 'रङ पछ्याउन सकेन — यी रङका पत्ता छैनन्',
  'bh.round': 'चरण {n}',
  'bh.discarded': 'हटाइएका {n}',
  'bh.lead': 'सुरु',
  'bh.firstHint': 'तपाईंसँग हुकुमको एक्का छ — त्यही चल्नुहोस्',
  'bh.leadHint': 'कुनै पनि पत्ता चल्नुहोस्',
  'bh.dumpHint': '{suit} छैन? कुनै पनि पत्ता चल्नुहोस् — त्यो थुप्रो उठाउनेलाई जान्छ',
  'bh.followHint': 'रङ पछ्याउनुहोस्: {suit}',
  'bh.pickup': '{name} ले {n} पत्ता उठायो',
  'bh.discard': 'चरण सकियो — अर्को {name} चल्छ',
  'bh.thulla': 'थुल्ला!',
  'bh.noBhabhi': 'सबै बाहिर भए — कोही भाउजू छैन!',
  'bh.isBhabhi': '{name} भाउजू बन्यो!',
  'bh.player': 'खेलाडी',
  'bh.cardsLeft': 'बाँकी पत्ता',
  'bh.outShort': 'बाहिर',
  'bh.scoreHint': 'आफ्ना सबै पत्ता निकाल्नुहोस्। चलिएको रङ पछ्याउनुहोस्; सबैले पछ्याए चरण हटाइन्छ र सबैभन्दा ठूलो पत्ताले अर्को चल्छ। रङ नभए कुनै पनि पत्ता चल्नुहोस् — चलिएको रङको सबैभन्दा ठूलो पत्ताले सबै थुप्रो उठाउँछ। अन्तमा पत्ता बाँकी हुने भाउजू हुन्छ।',
  'pr.cards': '{n} पत्ता',
  'pr.out': 'बाहिर · {n}',
  'pr.president': 'प्रेसिडेन्ट',
  'pr.vice': 'भाइस प्रेसिडेन्ट',
  'pr.neutral': 'न्युट्रल',
  'pr.scum': 'स्कम',
  'pr.leadHint': 'तपाईंको पालो — एक पत्ता वा बराबर पत्ताको सेट चल्नुहोस्',
  'pr.followHint': '{n} ठूला पत्ताले काट्नुहोस् — वा पास गर्नुहोस्',
  'pr.passed': 'पास',
  'pr.play': 'चल्नुहोस्',
  'pr.pass': 'पास',
  'pr.cleared': 'थुप्रो सफा',
  'pr.clearedTwo': '{name} ले दुई चल्यो — थुप्रो सफा',
  'pr.clearedPasses': 'सबैले पास गरे — {name} ले सुरु गर्छ',
  'pr.pile': 'थुप्रो {n}',
  'pr.player': 'खेलाडी',
  'pr.cardsLeft': 'बाँकी पत्ता',
  'pr.outShort': 'बाहिर',
  'pr.scoreHint': 'सबैभन्दा पहिले सबै पत्ता निकाल्नुहोस्। उत्तिकै ठूला पत्ताले थुप्रो काट्नुहोस् वा पास गर्नुहोस्; दुई सबैभन्दा ठूलो हो र थुप्रो सफा गर्छ। अन्तमा पत्ता बाँकी हुने स्कम हो।',
  'gf.cards': '{n} पत्ता',
  'gf.books': '{n} बुक',
  'gf.booksOf': 'बनेका बुक',
  'gf.stock': 'स्टक: {n}',
  'gf.empty': 'अहिलेसम्म कुनै माग छैन',
  'gf.pickHint': 'आफ्नो पत्ता छानेर रयाङ्क तोक्नुहोस्, त्यसपछि खेलाडी छान्नुहोस्',
  'gf.askHint': '{rank} माग्नुहोस् — खेलाडी छान्नुहोस्',
  'gf.ask': '{name} सँग माग्नुहोस्',
  'gf.logHit': '{a} ले {b} बाट {n} × {rank} लिए',
  'gf.logMiss': '{a} ले {b} सँग {rank} मागे — गो फिस!',
  'gf.logLuck': '{a} ले {rank} पाए — फेरि!',
  'gf.logNoLuck': '{a} ले {b} सँग {rank} मागे — भएन',
  'gf.wins': '{name} {n} बुकसहित जित्नुभयो',
  'gf.player': 'खेलाडी',
  'gf.booksCol': 'बुक',
  'gf.cardsCol': 'पत्ता',
  'gf.scoreHint': 'आफूसँग भएको रयाङ्क कुनै खेलाडीसँग माग्नुहोस्। पाइयो भने फेरि माग्नुहोस्, नत्र गो फिस। एउटै रयाङ्कका चार पत्ता = एक बुक — धेरै बुक भएको जित्छ।',
  'wr.cards': '{n} पत्ता',
  'wr.rounds': '{n} जित्यो',
  'wr.round': 'राउन्ड {n} / {max}',
  'wr.table': 'टेबल',
  'wr.laid': 'उल्टा पत्ता: तपाईं {a} · विपक्षी {b}',
  'wr.raised': '{name} ले बढायो',
  'wr.stayed': 'बढोत्तरी छैन',
  'wr.flip': 'पत्ता पल्टाउनुहोस्',
  'wr.stay': 'रोकिनुहोस्',
  'wr.raise': '+१ पत्ता थप्नुहोस्',
  'wr.player': 'खेलाडी',
  'wr.cardsCol': 'पत्ता',
  'wr.roundsCol': 'जितेका राउन्ड',
  'wr.scoreHint': 'हरेक राउन्डमा एक पत्ता पल्टाउनुहोस्; ठूलो पत्ताले दुवै लैजान्छ। बराबरी भए युद्ध: रोकिनुहोस् वा बढाउनुहोस्, उल्टा पत्ता राखेर फेरि पल्टाउनुहोस्। {max} राउन्डपछि धेरै पत्ता हुने जित्छ।',
  'wr.over': '{name} ले म्याच जित्यो',
  'wr.war': 'युद्ध! टेबलमा {n} पत्ता',
  'wr.roundWon': '{name} ले {n} पत्ता लिए',
  'wr.yourFlip': 'तपाईंको पालो',
  'wr.waiting': '{name} को पर्खाइ',
  'pr.empty': 'कुनै पनि पत्ता वा सेट चल्नुहोस्',
  'pr.isScum': '{name} स्कम हो',
  'pr.selectHint': 'एउटै नम्बरका पत्ता छान्नुहोस्, अनि चल्नुहोस् थिच्नुहोस्',
  'pn.noMeld': 'कुनै मेल्ड छैन',
  'pn.meld': 'मेल्ड',
  'pn.noTrick': 'कुनै चाल जितेन',
  'pn.passing': '{name} ले पत्ता दिँदैछ',
  'pn.passTitle': 'पत्ता दिनुहोस्',
  'pn.passToDeclarer': 'आफ्ना 3 सबैभन्दा राम्रा पत्ता घोषकलाई दिनुहोस्',
  'pn.passToPartner': '3 पत्ता साथीलाई फिर्ता दिनुहोस्',
  'pn.pick': '{n}/3 छानियो',
  'pn.passBtn': '3 पत्ता दिनुहोस्',
  'pn.bid': 'आफ्नो अंकको बोली',
  'pn.passHint': '{n} वा बढीको बोली लगाउनुहोस्, वा पास',
  'pn.scoreHint': '{target} पुग्ने पहिलो टोली जित्छ। टोलीले मेल्ड र काउन्टर (एक्का, 10, राजा र अन्तिम चाल — जम्मा 25) को अंक पाउँछ, तर कम्तीमा एक चाल जितेको भए मात्र; बोली नपुग्ने टोलीले आफ्नो बोली गुमाउँछ। रङ पछ्याउनुपर्छ र सकिए जित्ने पत्ताभन्दा ठूलो पत्ता चल्नुपर्छ; रङ नभए तुरुप चल्नुपर्छ।',
  'ab.andar': 'भित्र',
  'ab.bahar': 'बाहिर',
  'ab.joker': 'जोकर',
  'ab.pays': 'भुक्तानी {n}:1',
  'ab.noCards': 'पत्ता बाँडिने प्रतीक्षा',
  'ab.noBets': 'कुनै बाजी छैन',
  'ab.side': 'एक पक्ष छान्नुहोस्',
  'ab.bet': '{side} मा {n} को बाजी',
  'ab.wins': '{side} को जित!',
  'ab.youWon': 'तपाईंले {n} जित्नुभयो',
  'ab.youLost': 'तपाईंले {n} गुमाउनुभयो',
  'ab.dealing': 'पत्ता बाँडिँदैछ…',
  'ab.yourBet': 'तपाईंको बाजी: {side} मा {n}',
  'br.declarer': 'डिक्लेयरर',
  'br.dummy': 'डमी',
  'br.vul': 'भल्नरेबल',
  'br.deal': 'दौर {n}/{total}',
  'br.by': '{name} द्वारा',
  'br.auction': 'बोली',
  'br.dealDone': 'दौर {n} सकियो',
  'br.passedOut': 'सबैले पास गरे — कुनै अंक छैन',
  'br.passedOutShort': 'सबै पास',
  'br.dummyHand': 'डमी ({seat})',
  'br.playFromDummy': 'डमीका लागि पत्ता छान्नुहोस्',
  'br.contract': 'कन्ट्र्याक्ट',
  'br.yourCall': 'तपाईंको बोली',
  'br.last': 'अन्तिम बोली',
  'br.noBids': 'अहिलेसम्म कुनै बोली छैन',
  'br.level': 'तह',
  'br.strain': 'रङ',
  'br.pass': 'पास',
  'br.scoreHint': '{deals} दौरको शिकागो खेल: बढी कुल अंक पाउने जित्छ। भल्नरेबिलिटी: पहिले कोही होइन, त्यसपछि डिलरको टोली दुई पटक, अनि दुवै। कन्ट्र्याक्ट पुरा गर्दा चालका अंक र बोनस (गेम 300/500, स्ल्याम, डबल) पाइन्छ; असफल हुँदा विपक्षीले प्रति चाल 50/100 पाउँछन्। डिक्लेयररले डमीका पत्ता पनि चल्छ।',
  'sv.board': 'टेबलमा पत्ता',
  'sv.passes': 'पास गरेको पटक',
  'sv.passTag': 'पास {n}',
  'sv.over': 'खेल सकियो',
  'sv.startHint': 'तपाईंसँग ईंटको 7 छ — त्यही चलेर सुरु गर्नुहोस्',
  'sv.playHint': 'चम्किएको पत्ता चल्नुहोस्',
  'sv.noPlay': 'चल्ने केही छैन — पास',
  'sv.scoreHint': 'सबैभन्दा पहिले आफ्ना सबै पत्ता निकाल्नुहोस्। हरेक रङ त्यसको 7 बाट सुरु गर्नुहोस्, त्यसपछि क्रमभन्दा ठीक माथि वा तलको पत्ता थप्नुहोस्। एक्का सबैभन्दा सानो हो। चल्न नसके पास गर्नुहोस्। अन्तमा पत्ता बाँकी हुने हार्छ।',
  'sc.deck': 'गड्डी {n}',
  'sc.table': 'टेबलमा पत्ता',
  'sc.empty': 'टेबल खाली छ',
  'sc.captured': '{card} ले {n} पत्ता लियो',
  'sc.trailed': '{card} राख्यो',
  'sc.scopa': 'स्कोपा!',
  'sc.choose': 'तपाईंको चाल',
  'sc.pickCard': 'चल्न पत्ता छान्नुहोस्',
  'sc.trail': '{card} राख्नुहोस्',
  'sc.capture': 'लिनुहोस्',
  'sc.dealResult': 'दौर {n} को अंक',
  'sc.cards': 'पत्ता',
  'sc.diamonds': 'ईंट',
  'sc.settebello': '7♦',
  'sc.primiera': 'प्रिमिएरा',
  'sc.scopas': 'स्कोपा',
  'sc.total': 'अंक',
  'sc.scoreHint': '{target} पुग्ने पहिलो टोली जित्छ। उस्तै मूल्यको पत्ता वा जोड बराबर पत्ता लिन पत्ता चल्नुहोस् (एक्का 1, गुलाम 8, रानी 9, राजा 10); लिन मिल्छ भने लिनैपर्छ। टेबल खाली गर्नु स्कोपा हो (1 अंक)। हरेक दौरमा धेरै पत्ता, धेरै ईंट, 7♦ र उत्कृष्ट प्रिमिएराको पनि 1-1 अंक छ।',
  'se.deck': 'डेक {n}',
  'se.floor': 'भुइँमा रहेका पत्ता',
  'se.empty': 'भुइँ खाली छ',
  'se.took': '{card} ले {n} लिए',
  'se.trailed': '{card} राखियो',
  'se.built': '{card} ले {v} को घर बनायो',
  'se.seep': 'सीप!',
  'se.choose': 'तपाईंको चाल',
  'se.pickCard': 'खेल्न पत्ता छान्नुहोस्',
  'se.trail': '{card} राख्नुहोस्',
  'se.take': 'लिनुहोस्',
  'se.build': '{v} को घर बनाउनुहोस्',
  'se.raise': 'घरलाई {v} बनाउनुहोस्',
  'se.house': '{v} को घर',
  'se.dealResult': 'डील {n} को स्कोर',
  'se.cards': 'पत्ता',
  'se.cardPoints': 'पत्ताका अङ्क',
  'se.seeps': 'सीप',
  'se.total': 'अङ्क',
  'se.scoreHint': '{target} पुग्ने पहिलो टोली जित्छ। उही मानको भुइँको पत्ता वा जोडफल बराबर हुने पत्ता लिनुहोस् (एस 1, ज्याक 11, क्वीन 12, किङ 13), वा पछि लिन सकिने ९–१३ को घर बनाउनुहोस्। हुकुमका पत्ताले आफ्नो मान, अन्य एसले १ र १०♦ ले ६ अङ्क पाउँछन्; सीप (भुइँ खाली गर्नु) को ५० अङ्क।',
  'bc.player': 'प्लेयर',
  'bc.banker': 'बैंकर',
  'bc.tie': 'टाई',
  'bc.pays': 'भुक्तानी {n}:1',
  'bc.tieWins': 'टाई — दुवै हात बराबर',
  'bc.natural': 'नेचुरल',
  'bc.push': 'बाजी फिर्ता',
  'bc.bets': 'टेबलमा बाजी',
  'dt.dragon': 'ड्रागन',
  'dt.tiger': 'टाइगर',
  'dt.tie': 'टाई',
  'dt.tieWins': 'टाई — दुवै पत्ता बराबर',
  'tcp.ante': 'एन्टे',
  'tcp.pairPlus': 'पेयर प्लस',
  'tcp.dealer': 'डिलर',
  'tcp.yourHand': 'तपाईंको हात',
  'tcp.bet': 'एन्टे {n}',
  'tcp.betPP': 'एन्टे {n} + पेयर प्लस {pp}',
  'tcp.play': 'खेल्नुहोस् {n}',
  'tcp.fold': 'फोल्ड',
  'tcp.decide': 'खेल्ने कि फोल्ड?',
  'tcp.noQualify': 'डिलर क्वालिफाई गर्दैन',
  'tcp.dealerQualifies': 'डिलर क्वालिफाई गर्छ',
  'tcp.win': 'जित',
  'tcp.lose': 'हार',
  'tcp.push': 'बराबरी',
  'tcp.folded': 'फोल्ड',
  'tcp.bonus': 'बोनस {n}',
  'tcp.ppWin': 'पेयर प्लस {n}',
  'tcp.pairPlusBet': 'पेयर प्लस साइड बेट',
  'tcp.antePlay': 'एन्टे र प्ले',
  'tcp.youBet': 'एन्टे {n}',
  'tcp.cat.HIGH_CARD': 'हाई कार्ड',
  'tcp.cat.PAIR': 'जोडी',
  'tcp.cat.FLUSH': 'फ्लश',
  'tcp.cat.STRAIGHT': 'सिक्वेन्स',
  'tcp.cat.THREE_OF_A_KIND': 'तीन उस्तै',
  'tcp.cat.STRAIGHT_FLUSH': 'शुद्ध सिक्वेन्स',
  'tcp.wait': 'अरू खेलाडीको प्रतिक्षा…',
  'tcp.revealing': 'डिलरले पत्ता खोल्दैछ…',
  'pgw.dealer': 'डिलर',
  'pgw.yourHand': 'तपाईंका सात पत्ता',
  'pgw.pickLow': 'तल्लो हातका लागि दुई पत्ता छान्नुहोस्',
  'pgw.high': 'माथिल्लो हात (५ पत्ता)',
  'pgw.low': 'तल्लो हात (२ पत्ता)',
  'pgw.foul': 'पाँच पत्ताको हात दुई पत्ताको हातभन्दा ठूलो हुनुपर्छ',
  'pgw.houseWay': 'हाउस वे',
  'pgw.setHands': 'हात तय गर्नुहोस्',
  'pgw.bet': 'दाउ {n}',
  'pgw.youBet': 'दाउ {n}',
  'pgw.isSet': 'हात तय',
  'pgw.wait': 'अरू खेलाडीको पर्खाइ…',
  'pgw.revealing': 'डिलरले हात देखाउँदै…',
  'pgw.commission': 'कमिसन {n}',
  'pgw.highWon': 'माथिल्लो हात जित्यो',
  'pgw.highLost': 'माथिल्लो हात हार्यो',
  'pgw.lowWon': 'तल्लो हात जित्यो',
  'pgw.lowLost': 'तल्लो हात हार्यो',
  'pgw.cat.HIGH_CARD': 'हाई कार्ड',
  'pgw.cat.PAIR': 'जोडी',
  'pgw.cat.TWO_PAIR': 'दुई जोडी',
  'pgw.cat.THREE_OF_A_KIND': 'तीन समान',
  'pgw.cat.STRAIGHT': 'सिक्वेन्स',
  'pgw.cat.FLUSH': 'फ्लश',
  'pgw.cat.FULL_HOUSE': 'फुल हाउस',
  'pgw.cat.FOUR_OF_A_KIND': 'चार समान',
  'pgw.cat.STRAIGHT_FLUSH': 'स्ट्रेट फ्लश',
  'pgw.cat.ROYAL_FLUSH': 'रोयल फ्लश',
  'pgw.cat.FIVE_ACES': 'पाँच एक्का',
  'cw.dealer': 'डिलर',
  'cw.bet': 'बाजी {n}',
  'cw.tieBet': 'टाई बाजी',
  'cw.addTieBet': '{n} को टाई बाजी थप्नुहोस् ({p}:1)',
  'cw.yourBet': 'तपाईंको बाजी: {n}',
  'cw.tied': 'टाई! वार खेल्ने कि हार मान्ने?',
  'cw.war': 'वार खेल्नुहोस् (+{n})',
  'cw.surrender': 'हार मान्नुहोस् ({n} फिर्ता)',
  'cw.warOn': 'वार! तीन पत्ता जलाइयो',
  'cw.waitTie': '{name} को निर्णयको प्रतीक्षा…',
  'cw.outWin': 'तपाईंले {n} जित्नुभयो',
  'cw.outWar': 'वार जित्नुभयो: +{n}',
  'cw.outWarLost': 'वार हार्नुभयो: −{n}',
  'cw.outSurrender': 'हार मान्नुभयो: −{n}',
  'cw.warCard': 'वारको पत्ता',
  'cw.bets': 'खेलाडी',
  'rdg.spreadTitle': 'स्प्रेड',
  'rdg.thirdCard': 'तेस्रो पत्ता',
  'rdg.spread': 'स्प्रेड {n} · जितमा {p}:1',
  'rdg.consecutive': 'लगातार पत्ता — पुश',
  'rdg.pair': 'बराबर पत्ता — तेस्रो पत्ताले निर्धारण गर्छ',
  'rdg.ante': 'आफ्नो एन्टी राख्नुहोस्',
  'rdg.betAnte': 'एन्टी {n}',
  'rdg.yourBet': 'तपाईंको दाउ: {n}',
  'rdg.bets': 'खेलाडी',
  'rdg.decide': 'रेज गर्ने कि रोकिने?',
  'rdg.decideHint': 'स्प्रेड {n} · {p}:1',
  'rdg.raiseBy': 'रेज रकम',
  'rdg.raise': 'रेज +{n}',
  'rdg.stay': 'रोकिनुहोस्',
  'rdg.raised': 'रेज गरे',
  'rdg.stayed': 'रोकिए',
  'rdg.waitDecide': '{name} को निर्णयको पर्खाइमा…',
  'rdg.outWin': 'तपाईंले {n} जित्नुभयो',
  'rdg.outTrips': 'तीन उस्तै! +{n}',
  'rdg.outLose': 'तपाईंले {n} हार्नुभयो',
  'rdg.outPush': 'पुश — एन्टी फिर्ता',
  'bl.claim': 'दाबी',
  'bl.pile': 'थुप्रो {n}',
  'bl.empty': 'खाली',
  'bl.claimed': '{name} ले {n} × {rank} राख्यो',
  'bl.honest': 'साँचो! {name} ले थुप्रो उठायो ({n})',
  'bl.caught': 'झूट समातियो! {name} ले थुप्रो उठायो ({n})',
  'bl.winner': 'विजेता',
  'bl.wins': '{name} जित्यो!',
  'bl.call': 'ब्लफ भन्नुहोस्!',
  'bl.accept': 'मान्नुहोस् — {name} बाहिरिन्छ',
  'bl.pick': '{rank} भन्न पत्ता छान्नुहोस्',
  'bl.play': '{n} पत्ता {rank} भनेर राख्नुहोस्',
  'bl.scoreHint': 'सबैभन्दा पहिले सबै पत्ता निकाल्ने जित्छ; बाँकीलाई बाँकी पत्ताले क्रम दिइन्छ। १–४ पत्ता उल्टो राखेर माग्ने दर्जा भन्नुहोस् — तपाईं झूट बोल्न सक्नुहुन्छ। अर्को खेलाडीले ब्लफ भन्न सक्छ: झूट भए तपाईंले सबै थुप्रो उठाउनुहुन्छ, नत्र उसले। जित्न अन्तिम पत्ताले पनि चुनौती पार गर्नुपर्छ।',
  'pn.m.run': 'क्रम',
  'pn.m.doubleRun': 'दोहोरो क्रम',
  'pn.m.royal': 'शाही जोडी',
  'pn.m.marriage': 'जोडी',
  'pn.m.dix': 'डिक्स',
  'pn.m.pinochle': 'पिनोकल',
  'pn.m.doublePinochle': 'दोहोरो पिनोकल',
  'pn.m.aces': 'चारै एक्का',
  'pn.m.kings': 'चारै राजा',
  'pn.m.queens': 'चारै रानी',
  'pn.m.jacks': 'चारै गुलाम',
  'pn.m.doubleAces': 'दोहोरो एक्का',
  'pn.m.doubleKings': 'दोहोरो राजा',
  'pn.m.doubleQueens': 'दोहोरी रानी',
  'pn.m.doubleJacks': 'दोहोरो गुलाम',
  'game.TEEN_PATTI': 'तीन पत्ती',
  'game.POKER': 'पोकर',
  'game.MARRIAGE': 'म्यारिज',
  'tables.title': 'टेबल छान्नुहोस्',
  'tables.entry': 'प्रवेश',
  'tables.play': 'खेल्नुहोस्',
  'mm.searching': 'खेलाडी खोज्दैछौं…',
  'mm.cancel': 'रद्द',
  'mm.matched': 'टेबल भेटियो!',
  'table.leave': 'छोड्नुहोस्',
  'table.yourTurn': 'तपाईंको पालो',
  'table.waitingFor': '{name} को पालो',
  'table.imBack': 'म फर्किएँ',
  'table.round': 'राउन्ड {n}/{total}',
  'cb.bid': 'कति हात? कल गर्नुहोस्',
  'tp.see': 'पत्ता हेर्नुहोस्',
  'tp.chaal': 'चाल {n}',
  'tp.blind': 'ब्लाइन्ड {n}',
  'tp.raise': 'बढाउनुहोस् {n}',
  'tp.pack': 'प्याक',
  'tp.show': 'शो {n}',
  'tp.sideShow': 'साइड शो {n}',
  'pk.fold': 'फोल्ड',
  'pk.check': 'चेक',
  'pk.call': 'कल {n}',
  'pk.allIn': 'अल-इन',
  'mr.drawStock': 'तान्नुहोस्',
  'mr.pickDiscard': 'उठाउनुहोस्',
  'mr.discard': 'फाल्नुहोस्',
  'mr.show': 'देखाउनुहोस् (जोकर हेर्न)',
  'mr.finish': 'खेल सकाउनुहोस्',
  'results.title': 'नतिजा',
  'results.won': 'तपाईंले {n} सिक्का जित्नुभयो!',
  'results.lost': 'तपाईंले {n} सिक्का हार्नुभयो',
  'results.playAgain': 'फेरि खेल्नुहोस्',
  'results.lobby': 'लबी',
  'rooms.create': 'निजी कोठा बनाउनुहोस्',
  'rooms.invite': 'साथीलाई बोलाउनुहोस्',
  'rooms.start': 'खेल सुरु गर्नुहोस्',
  'friends.title': 'साथीहरू',
  'friends.add': 'थप्नुहोस्',
  'friends.accept': 'स्वीकार',
  'friends.reject': 'अस्वीकार',
  'profile.title': 'प्रोफाइल',
  'profile.played': 'खेलेको',
  'profile.won': 'जितेको',
  'settings.title': 'सेटिङ',
  'settings.language': 'भाषा',
  'settings.sound': 'आवाज',
  'settings.music': 'संगीत',
  'settings.legal': 'सिक्का भर्चुअल हुन्, नगद मूल्य छैन र निकाल्न मिल्दैन।',
  'daily.title': 'दैनिक इनाम',
  'daily.day': 'दिन {n}',
  'daily.claim': 'इनाम लिनुहोस्',
  'missions.title': 'मिसनहरू',
  'store.title': 'सिक्का पसल',
  'lb.title': 'लिडरबोर्ड',
  'notif.title': 'सूचनाहरू',
  'app.name': 'Card Hub',
  'common.yes': 'हो',
  'common.no': 'होइन',
  'common.free': 'निःशुल्क',
  'common.comingSoon': 'छिट्टै आउँदैछ',
  'common.bot': 'BOT',
  'error.sessionExpired': 'तपाईंको सत्र सकियो। कृपया फेरि साइन इन गर्नुहोस्।',
  'onboard.username.hint': '३–२० अक्षर, अंक वा _',
  'onboard.signup.body': 'जुनसुकै डिभाइसमा साइन इन गर्न पासवर्ड राख्नुहोस्। इमेल ऐच्छिक हो र खाता फिर्ता पाउन मद्दत गर्छ।',
  'onboard.bonus.pending': 'तपाईंको स्वागत बोनस जाँच हुँदैछ र छिट्टै आइपुग्नेछ।',
  'onboard.tutorial.body': 'एक मिनेटभन्दा कममा आधारभूत कुरा सिक्नुहोस्, वा सिधै खेल्न सुरु गर्नुहोस्।',
  'auth.identifier': 'युजरनेम वा इमेल',
  'auth.email': 'इमेल (ऐच्छिक)',
  'auth.referral': 'रेफरल कोड (ऐच्छिक)',
  'auth.phone': 'फोन नम्बर',
  'auth.sendCode': 'कोड पठाउनुहोस्',
  'auth.code': '६ अंकको कोड',
  'auth.verify': 'प्रमाणित गर्नुहोस्',
  'auth.usePhone': 'फोन नम्बर प्रयोग गर्नुहोस्',
  'auth.usePassword': 'युजरनेम र पासवर्ड प्रयोग गर्नुहोस्',
  'auth.noAccount': 'नयाँ हुनुहुन्छ? खाता बनाउनुहोस्',
  'lobby.events': 'कार्यक्रमहरू',
  'lobby.tournaments': 'प्रतियोगिताहरू',
  'lobby.tables': '{n} टेबल',
  'lobby.entry': 'प्रवेश {min}–{max}',
  'lobby.continueGame': 'तपाईंको एउटा खेल जारी छ',
  'tables.buyIn': 'बाइ-इन',
  'tables.minBalance': 'न्यूनतम ब्यालेन्स {n}',
  'tables.players': '{min}–{max} खेलाडी',
  'tables.timer': '{n} सेकेन्ड पालो',
  'tables.cantAfford': '{n} चाहिन्छ',
  'mm.waited': '{s} सेकेन्डदेखि खोज्दै',
  'mm.failed': 'त्यो टेबल सुरु गर्न सकिएन।',
  'table.leaveConfirm': 'यो टेबल छोड्ने?',
  'table.leaveMatchWarn': 'खेल बोटसँग जारी रहन्छ र तपाईंको प्रवेश शुल्क जान्छ।',
  'table.leaveSessionWarn': 'बाँकी चिप्स तपाईंको वालेटमा फर्किन्छन्।',
  'table.waitingPlayers': 'खेलाडी पर्खँदै…',
  'offline.title': 'तपाईं अफलाइन हुनुहुन्छ',
  'offline.body': 'तपाईं अझै आफ्ना सामान्य टेबलहरूमा बटहरूविरुद्ध हरेक खेल खेल्न सक्नुहुन्छ। अनलाइन हुनासाथ सिक्का, XP र तथ्याङ्क अपडेट हुनेछन्।',
  'offline.tile': 'अफलाइन खेल्नुहोस्',
  'offline.play': 'अफलाइन खेल्नुहोस्',
  'offline.pending': '{n} अफलाइन खेल अनलाइन हुनासाथ जोडिनेछन्।',
  'table.autoPlay': 'अटो-प्ले चालु छ',
  'table.hand': 'हात #{n}',
  'table.pot': 'कुल पोट',
  'install.title': 'Card Hub इन्स्टल गर्नुहोस्',
  'install.body': 'फुल स्क्रिनमा खेल्नुहोस् र होम स्क्रिनबाटै खोल्नुहोस्।',
  'install.button': 'इन्स्टल गर्नुहोस्',
  'install.later': 'अहिले होइन',
  'install.howTo': 'इन्स्टल कसरी गर्ने',
  'install.ios': 'ब्राउजरमा सेयर बटन थिच्नुहोस्, त्यसपछि “Add to Home Screen” छान्नुहोस्।',
  'install.android': 'ब्राउजर मेनु (तीन थोप्ला) खोल्नुहोस्, त्यसपछि “Install app” वा “Add to Home screen” थिच्नुहोस्।',
  'table.chat': 'च्याट',
  'table.send': 'पठाउनुहोस्',
  'table.scores': 'स्कोर',
  'table.away': 'टाढा',
  'cb.bidValue': 'कल {n}',
  'cb.tricks': '{won}/{bid}',
  'cb.suggested': 'सुझाव',
  'cb.playCard': 'एउटा पत्ती खेल्नुहोस्',
  'tp.sideShowAsk': '{name} साइड शो माग्दै हुनुहुन्छ',
  'tp.accept': 'स्वीकार',
  'tp.decline': 'अस्वीकार',
  'tp.stake': 'दाउ {n}',
  'tp.blindTag': 'ब्लाइन्ड',
  'tp.seenTag': 'हेरेको',
  'tp.packedTag': 'प्याक',
  'pk.bet': 'बेट {n}',
  'pk.raiseTo': '{n} सम्म रेज',
  'pk.halfPot': '½ पट',
  'pk.pot': 'पट',
  'pk.min': 'न्यूनतम',
  'mr.tiplu': 'टिप्लु: {card}',
  'mr.hiddenJoker': 'शो नगरेसम्म जोकर लुकेको छ',
  'mr.selectShow': '३ वटा शुद्ध सिक्वेन्स वा टनेला छान्नुहोस्',
  'mr.stock': 'स्टक {n}',
  'mr.autoArrange': 'आफैं मिलाउनुहोस्',
  'results.handResult': 'हातको नतिजा',
  'results.place': '#{n}',
  'results.xp': '+{n} XP',
  'results.levelUp': 'लेभल अप! तपाईं लेभल {n} पुग्नुभयो',
  'results.rating': 'रेटिङ {r} ({d})',
  'results.bonusAd': 'विज्ञापन हेरेर +{n}',
  'rooms.game': 'खेल',
  'rooms.table': 'टेबल',
  'rooms.password': 'पासवर्ड (ऐच्छिक)',
  'rooms.code': 'रुम कोड',
  'rooms.waiting': 'होस्टले सुरु गर्न पर्खँदै…',
  'rooms.members': 'खेलाडी ({n}/{max})',
  'rooms.lock': 'रुम लक गर्नुहोस्',
  'rooms.unlock': 'रुम अनलक गर्नुहोस्',
  'rooms.cancel': 'रुम बन्द गर्नुहोस्',
  'rooms.remove': 'हटाउनुहोस्',
  'rooms.join': 'रुममा जोडिनुहोस्',
  'rooms.enterCode': 'रुम कोड लेख्नुहोस्',
  'rooms.shareText': 'Card Hub मा मेरो {game} टेबलमा आउनुहोस्! कोड {code}: {url}',
  'friends.search': 'खेलाडी खोज्नुहोस्',
  'friends.requests': 'अनुरोधहरू',
  'friends.recent': 'हालै सँगै खेलेका',
  'friends.empty': 'अहिलेसम्म साथी छैनन्। खेलाडी खोज्नुहोस् वा साथीलाई निम्तो दिनुहोस्!',
  'friends.inviteLink': 'आफ्नो लिङ्कबाट निम्तो दिनुहोस्',
  'friends.status.idle': 'अनलाइन',
  'friends.status.in_game': 'खेल्दै',
  'friends.status.offline': 'अफलाइन',
  'friends.block': 'ब्लक',
  'friends.unblock': 'अनब्लक',
  'friends.report': 'रिपोर्ट',
  'friends.remove': 'साथीबाट हटाउनुहोस्',
  'friends.requestSent': 'अनुरोध पठाइयो',
  'profile.stats': 'तथ्याङ्क',
  'profile.winRate': 'जित दर',
  'profile.rating': 'रेटिङ',
  'profile.achievements': 'उपलब्धिहरू',
  'profile.history': 'खेल इतिहास',
  'profile.wallet': 'वालेट इतिहास',
  'profile.referral': 'निम्तो दिनुहोस् र कमाउनुहोस्',
  'profile.editName': 'नाम बदल्नुहोस्',
  'settings.theme': 'थिम',
  'settings.theme.dark': 'गाढा',
  'settings.theme.light': 'उज्यालो',
  'settings.theme.system': 'सिस्टम',
  'settings.volume': 'मुख्य भोल्युम',
  'settings.haptics': 'ह्याप्टिक कम्पन',
  'settings.graphics': 'ग्राफिक्स गुणस्तर',
  'settings.reducedMotion': 'एनिमेसन घटाउनुहोस्',
  'settings.highContrast': 'उच्च कन्ट्रास्ट',
  'settings.fontSize': 'अक्षरको आकार',
  'settings.colorBlind': 'चार रङको तास (रङ-अन्धोपन मैत्री)',
  'settings.notifications': 'सूचनाहरू',
  'settings.privacy': 'गोपनीयता',
  'settings.showOnline': 'म अनलाइन भएको देखाउनुहोस्',
  'settings.allowRequests': 'साथी अनुरोध अनुमति दिनुहोस्',
  'settings.leaderboards': 'मलाई लिडरबोर्डमा देखाउनुहोस्',
  'settings.analytics': 'बेनामी प्रयोग डेटा साझा गर्नुहोस्',
  'settings.account': 'खाता',
  'settings.export': 'मेरो डेटा डाउनलोड गर्नुहोस्',
  'settings.delete': 'खाता मेटाउनुहोस्',
  'settings.deleteConfirm': 'यसले तपाईंको खाता सधैंका लागि मेटाउँछ। पुष्टि गर्न DELETE टाइप गर्नुहोस्।',
  'settings.help': 'मद्दत र प्रश्नोत्तर',
  'notif.friendRequests': 'साथी अनुरोध',
  'notif.gameInvites': 'खेल निम्तो',
  'notif.dailyReward': 'दैनिक इनाम',
  'notif.missions': 'मिसन र उपलब्धि',
  'notif.tournaments': 'प्रतियोगिता',
  'notif.yourTurn': 'तपाईंको पालो',
  'notif.promotions': 'अफर र कार्यक्रम',
  'notif.empty': 'सबै हेरिसक्नुभयो।',
  'notif.markAll': 'सबै पढेको चिन्ह लगाउनुहोस्',
  'daily.comeBack': 'भोलि फेरि आउनुहोस्',
  'missions.daily': 'दैनिक',
  'missions.weekly': 'साप्ताहिक',
  'missions.resets': '{time} मा रिसेट हुन्छ',
  'store.buy': 'किन्नुहोस्',
  'store.disabled': 'अहिले खरिद उपलब्ध छैन।',
  'store.note': 'सिक्का मनोरञ्जनका लागि मात्र हुन् र नगदमा साट्न मिल्दैन।',
  'store.freeCoins': 'निःशुल्क सिक्का',
  'ads.watch': 'छोटो भिडियो हेर्नुहोस्',
  'ads.reward': '{n} सिक्का कमाउनुहोस्',
  'ads.playing': 'विज्ञापन चल्दैछ… {s} सेकेन्ड',
  'ads.limit': 'दैनिक सीमा पुग्यो',
  'ads.credited': '+{n} सिक्का थपियो!',
  'lb.daily': 'आज',
  'lb.weekly': 'हप्ता',
  'lb.monthly': 'महिना',
  'lb.allTime': 'सधैंको',
  'lb.wins': 'जित',
  'lb.xp': 'XP',
  'lb.games': 'खेल',
  'lb.coins': 'जितेका सिक्का',
  'lb.all': 'सबै खेल',
  'lb.you': 'तपाईं: #{rank}',
  'lb.empty': 'यस अवधिमा अहिलेसम्म स्कोर छैन। बोर्डमा आउन एक खेल खेल्नुहोस्!',
  'tut.next': 'अर्को',
  'tut.practice': 'बोटसँग अभ्यास',
  'tut.replay': 'ट्युटोरियल फेरि हेर्नुहोस्',
  'help.title': 'मद्दत र प्रश्नोत्तर',
  'report.title': 'खेलाडी रिपोर्ट गर्नुहोस्',
  'report.reason': 'कारण',
  'report.details': 'विवरण (ऐच्छिक)',
  'report.submit': 'रिपोर्ट पठाउनुहोस्',
  'report.thanks': 'धन्यवाद — हाम्रा मोडरेटरले यसको समीक्षा गर्नेछन्।',
  'settings.security': 'सुरक्षा',
  'mfa.title': 'दुई-चरण प्रमाणीकरण',
  'mfa.onBody': 'चालु — साइन इन गर्न अथेन्टिकेटर एपको कोड चाहिन्छ।',
  'mfa.offBody': 'अथेन्टिकेटर एपले आफ्नो खाता सुरक्षित गर्नुहोस्। स्टाफका लागि अनिवार्य।',
  'mfa.setup': 'सेटअप गर्नुहोस्',
  'mfa.scan': 'Google Authenticator, Microsoft Authenticator वा 1Password ले स्क्यान गर्नुहोस्, अनि ६ अंकको कोड लेख्नुहोस्।',
  'mfa.enable': 'सक्रिय गर्नुहोस्',
  'mfa.disable': 'निष्क्रिय गर्नुहोस्',
  'mfa.enabled': 'दुई-चरण प्रमाणीकरण सक्रिय भयो',
  'mfa.disabled': 'दुई-चरण प्रमाणीकरण निष्क्रिय भयो',
  'mfa.code': 'अथेन्टिकेटर कोड',
  'mfa.loginHint': 'यो खातामा दुई-चरण प्रमाणीकरण चालु छ।',
  'mfa.qr': 'अथेन्टिकेटर QR कोड',
  'replay.title': 'रिप्ले',
  'replay.watch': 'रिप्ले हेर्नुहोस्',
  'replay.controls': 'रिप्ले नियन्त्रण',
  'replay.start': 'सुरुमा जानुहोस्',
  'replay.prev': 'अघिल्लो चरण',
  'replay.next': 'अर्को चरण',
  'replay.play': 'चलाउनुहोस्',
  'replay.pause': 'रोक्नुहोस्',
  'replay.position': 'रिप्ले स्थिति',
  'replay.step': 'चरण {n} / {total}',
  'replay.speed': 'प्ले गति',
  'watch.title': 'लाइभ हेर्नुहोस्',
  'watch.cta': 'हेर्नुहोस्',
  'watch.banner': 'हेर्दै — पत्ती लुकेका रहन्छन्',
  'cosmetics.title': 'पत्तीको पछाडि र टेबल',
  'cosmetics.cardBack': 'पत्तीको पछाडि',
  'cosmetics.felt': 'टेबलको रङ',
  'cosmetics.locked': 'लेभल {n} मा खुल्छ',
  'cosmetics.back.classic': 'क्लासिक',
  'cosmetics.back.crimson': 'रातो',
  'cosmetics.back.midnight': 'मध्यरात',
  'cosmetics.back.saffron': 'केसरी',
  'cosmetics.back.himalaya': 'हिमालय',
  'cosmetics.back.gold': 'सुनौलो',
  'cosmetics.felt.emerald': 'पन्ना',
  'cosmetics.felt.royal': 'शाही नीलो',
  'cosmetics.felt.maroon': 'मरुन',
  'cosmetics.felt.charcoal': 'कोइला',
  'cosmetics.felt.teal': 'टिल',
  'theme.toLight': 'उज्यालो मोडमा जानुहोस्',
  'theme.toDark': 'गाढा मोडमा जानुहोस्',
  'cb.yourCall': 'तपाईंको कल',
  'cb.moreBids': '९ देखि १३ देखाउनुहोस्',
};
